<template>
  <b-row class="d-flex align-items-center">
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Bölüm"
        label-for="component"
      >
        <v-select
          id="component"
          v-model="filterParams.component"
          :options="components"
          placeholder="Bölüm"
          :reduce="item => item.value"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Kullanıcı"
        label-for="id_users"
      >
        <v-select
          id="id_users"
          v-model="filterParams.id_users"
          :options="users"
          placeholder="Kullanıcı"
          label="name"
          :reduce="item => item.id"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Durum"
        label-for="is_used"
      >
        <v-select
          id="is_used"
          v-model="filterParams.is_used"
          :options="statuses"
          placeholder="Durum"
          :reduce="item => item.value"
          :clearable="false"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Başlangıç Tarihi"
        label-for="sdate"
      >
        <b-form-datepicker
          id="sdate"
          v-model="filterParams.sdate"
          v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
          locale="tr"
          start-weekday="1"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <b-form-group
        label="Bitiş Tarihi"
        label-for="edate"
      >
        <b-form-datepicker
          id="edate"
          v-model="filterParams.edate"
          v-bind="{labelNoDateSelected: 'Bitiş Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
          locale="tr"
          start-weekday="1"
        />
      </b-form-group>
    </b-col>
    <b-col
      cols="12"
      md="auto"
    >
      <b-button
        variant="primary"
        style="margin-top: 5px"
        @click="getDataList"
      >
        <FeatherIcon icon="FilterIcon" /> Filtrele
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
import vSelect from 'vue-select'
import {
  BRow, BCol, BFormGroup, BButton, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'FilterCard',
  components: {
    BFormDatepicker,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BButton,
  },
  props: {
    getDataList: {
      type: Function,
      required: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['downloadLogs/filterParams']
    },
    components() {
      return this.$store.getters['downloadLogs/components']
    },
    users() {
      return this.$store.getters['users/dataList']
    },
    statuses() {
      return [
        { label: 'Tüm Kayıtlar', value: null },
        { label: 'İndirme Başarılı', value: '1' },
        { label: 'İndirme Başarsız / İptal', value: '0' },
      ]
    },
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      this.$store.dispatch('users/getDataList')
    },
  },
}
</script>
